import { HTMLAttributeReferrerPolicy } from 'react'

import type { LinkedLinkProps } from 'shared-definitions/types'
import type { ApiObjectLink } from 'data-source/types.wp'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { externalLinkRegexp } from 'shared-code/regexp'

export const clearbuyLinkExternalMapper = (href: string): LinkedLinkProps => ({ href })

const mapString = (input: string, opts: PLinkMapperOpts): LinkedLinkProps => {
  const external = externalLinkRegexp.test(input)
  if (external) {
    return clearbuyLinkExternalMapper(input)
  }

  return opts.postLinkBuilder(input)
}

const mapObject = (input: ApiObjectLink): LinkedLinkProps => ({
  href: input.href,
  referrerPolicy: input.referrerpolicy as HTMLAttributeReferrerPolicy,
  target: input.target,
})

export const clearbuyLinkMapper = (
  input: string | ApiObjectLink,
  opts: PLinkMapperOpts
): LinkedLinkProps => {
  if (typeof input === 'string') {
    return mapString(input, opts)
  }

  return mapObject(input)
}

export const clearbuyOptionalLinkMapper = (input?: string): LinkedLinkProps | null => {
  if (!input) {
    return null
  }

  return clearbuyLinkExternalMapper(input)
}
